'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _ApplicationContainer = require('conversations-visitor-ui/containers/ApplicationContainer');

var _ApplicationContainer2 = _interopRequireDefault(_ApplicationContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var APP_BASE = '/conversations-visitors/:portalId';

exports.default = _react2.default.createElement(_reactRouter.Route, { name: 'widget-base', path: APP_BASE, component: _ApplicationContainer2.default });
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/Routes.js
// module id = 449
// module chunks = 0